export default __webpack_public_path__ + "26dab2f9acea905336dc564aa6993fd5.png";